module.exports = __webpack_public_path__ + "img/markerTramBlue.82c5970a.svg";